import "./Home.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PropertyManagementExitSolutions from "./sections/PropertyManagementExitSolutions";
import Management from "./sections/Management";
import TheImiAdvantage from "./sections/TheImiAdvantage";
import ClientExperiences from "./sections/ClientExperiences";
import OurCredentials from "./sections/OurCredentials";
import Marketplace from "./sections/Marketplace";
import Login from "./sections/Login";
import FooterLegal from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainNavigation />
      <PropertyManagementExitSolutions />
      <Management />
      <TheImiAdvantage />
      <ClientExperiences />
      <OurCredentials />
      <Marketplace />
      <Login />
      <FooterLegal />
    </div>;
}